import OperatorTdsDeclarationTypes from './types';

const initialOperatorDetailsData = {
  street: '',
  state: '',
  pinCode: '',
  city: '',
  fatherName: '',
  name: '',
  number: '',
  opCode: '',
  vehicleNumber: [],
  currentDate: '',
  panNumber: '',
  startDate: '',
  endDate: '',
};

const defaultState = {
  operatorDetails: { ...initialOperatorDetailsData },
  isFetching: false,

  errorText: '',
  tdsDeclared: false,
};

const operatorTdsDeclarationReducer = (
  state: any = defaultState,
  action: { type: string; payload: any; response: any },
) => {
  switch (action.type) {
    case OperatorTdsDeclarationTypes.FETCH_OPERATOR_DETAILS_START: {
      return {
        ...state,
        isFetching: true,
      };
    }
    case OperatorTdsDeclarationTypes.FETCH_OPERATOR_DETAILS_SUCCESS: {
      const listData = action.payload?.data?.data || [];
      console.log('listDttat', listData);

      let newListObj: any = {};
      newListObj = { ...state.operatorDetails };
      newListObj.currentDate = listData.currentDate;
      newListObj.fatherName = listData.fatherName;
      newListObj.state = listData.state;
      newListObj.pinCode = listData.pinCode;
      newListObj.city = listData.city;
      newListObj.fatherName = listData.fatherName;
      newListObj.name = listData.name;
      newListObj.number = listData.number;
      newListObj.street = listData.street;
      newListObj.opCode = listData.opCode;
      newListObj.currentDate = listData.currentDate;
      newListObj.panNumber = listData.panNumber;

      newListObj.endDate = listData.endDate;
      newListObj.startDate = listData.startDate;
      newListObj.vehicleNumber = listData.vehicleNumber;

      return { ...state, operatorDetails: newListObj, isFetching: false };
    }

    case OperatorTdsDeclarationTypes.FETCH_OPERATOR_DETAILS_FAILURE: {
      return { ...state, isFetching: false };
    }

    case OperatorTdsDeclarationTypes.INITIATE_OPERATOR_TDS_DECLARATION_START: {
      return { ...state, isFetching: true };
    }

    case OperatorTdsDeclarationTypes.INITIATE_OPERATOR_TDS_DECLARATION_SUCCESS: {
      const data = action.payload?.data?.data || [];
      let newListObj: any = {};
      newListObj = { ...state.operatorDetails };
      newListObj.status = data.status;
      return { ...state, isFetching: false, tdsDeclared: true };
    }

    case OperatorTdsDeclarationTypes.INITIATE_OPERATOR_TDS_DECLARATION_FAILURE: {
      return { ...state, isFetching: false, errorText: action.payload.response.data.message };
    }

    default:
      return { ...state };
  }
};

export default operatorTdsDeclarationReducer;
